import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from "mobx-react";
import * as React from "react";
import { addDisplayName } from "../../Infra/display-name";
import { GlobalAdminViewParent } from "./GlobalAdminView.styles";
import { HXTab } from "../HXTab";
import { Outlet } from "react-router";
import { GlobalAdminViewModel } from "./GlobalAdminViewModel";
import { HXPageHeader, HXPageSubtabs, HXPageTitle } from "../HXDesktopPage";
import { useViewModel } from "../useViewModel";
export const GlobalAdminView = observer((props) => {
    const model = useViewModel(GlobalAdminViewModel, props.container);
    return (_jsxs(GlobalAdminViewParent, { children: [_jsx(HXPageHeader, { children: _jsx(HXPageTitle, { children: model.pageTitle }) }), _jsx(HXPageSubtabs, { value: model.currentTab, onChange: (_event, tab) => model.setCurrentTab(tab), children: model.tabsToShow.map(({ tab, label }) => (_jsx(HXTab, { value: tab, label: label, analyticsId: label.toLowerCase().replace(/\s+/g, "-") }, tab))) }), _jsx(Outlet, {})] }));
});
addDisplayName(GlobalAdminView, "GlobalAdminView");
